var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("label", { staticClass: "d-block mb-1 small" }, [_vm._v("Container")]),
    _vm._v(" "),
    _c(
      "select",
      {
        staticClass: "form-select form-select-sm w-auto",
        on: { change: _vm.savePageContainerId },
      },
      [
        _c("option", { attrs: { value: "", selected: "", disabled: "" } }, [
          _vm._v("Select…"),
        ]),
        _vm._v(" "),
        _vm._l(_vm.pageSectionTemplates, function (o) {
          return _c(
            "option",
            {
              key: o.id,
              domProps: {
                value: o.id,
                selected: o.id === _vm.section.pageContainerId,
              },
            },
            [_vm._v("\n            " + _vm._s(o.title) + "\n        ")]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }